<div class="editor-wrapper h-100" style="max-height: 100%;">
  <div class="editor-toolbar">
    <ng-container *ngIf="isReadOnly">
      <button class="bm-btn" (click)="startEdit()">
        <fa-icon [icon]="faEdit"></fa-icon> Bearbeiten
      </button>
    </ng-container>
    <ng-container *ngIf="!isReadOnly">
      <button class="bm-btn bm-btn-primary" (click)="save()">
        <fa-icon [icon]="faSave"></fa-icon>
      </button>
      <button class="bm-btn bm-btn-error" (click)="cancelEdit()">
        Abbrechen
      </button>
    </ng-container>
  </div>

  <div #editorContainer class="editor-content editorjs"></div>
</div>
